import { memo } from 'react';
import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { keyframes, styled } from '@prose-ui/legacy';

const widthKeyframes = keyframes`
  from { width: 0; }
  to { width: var(--final-width); }
`;
const BarStyle = styled.div`
  ${widthKeyframes};
  width: 0;
  /* see this bezier def at https://easings.net/#easeOutExpo */
  animation: ${widthKeyframes.name} var(--animation-duration) cubic-bezier(0.16, 1, 0.3, 1);
`;

const ProgressLine = memo(
  ({ backgroundColor, className, color, height, progress, animationDuration }) => {
    const borderRadius = parseInt(height, 10) / 2;
    const containerStyle = {
      backgroundColor,
      borderRadius,
      height,
    };
    const barStyle = {
      '--final-width': `${progress}%`,
      '--animation-duration': `${animationDuration}`,
      background: color,
      borderRadius,
      height: '100%',
      width: `var(--final-width)`,
    };

    return (
      <div className={className} style={containerStyle}>
        <BarStyle style={barStyle} />
      </div>
    );
  }
);

ProgressLine.defaultProps = {
  backgroundColor: theme.colors.primary[200],
  className: null,
  color: theme.colors.primary[400],
  height: '3px',
  progress: 0,
  // define the line width duration. No animation by default
  animationDuration: '0s',
};

ProgressLine.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  progress: PropTypes.number,
  animationDuration: PropTypes.string,
};

export default ProgressLine;
